import { IBooleanResponse } from '@gem/models/commonModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from '../error/errorBuilder';
import {
  ICatalog,
  ICatalogItemsList,
  ISupportedLocalesList,
  IGetCatalog,
  IGetCatalogWidget,
  ISearchCatalogItemsByName,
  ISearchCatalogItemsByCategory,
  IUserLocaleChange,
  IGetNewsfeed,
  INewsfeed,
  IHideNewsfeedPosts,
  IUnhideNewsfeedPosts,
  IGetStartPageItems,
  IStartPageItems,
  StartPageItemType,
} from './catalogModel.types';

// Needs Bff implementation
export const getCatalog = async (data: IGetCatalog): Promise<ICatalog> => {
  try {
    const catalog = {} as ICatalog;
    return catalog;
  } catch (error) {
    logger.get('API').error('catalog.getCatalog', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getWidgetItems = async (data: IGetCatalogWidget): Promise<ICatalogItemsList> => {
  try {
    const itemsList = {} as ICatalogItemsList;
    return itemsList;
  } catch (error) {
    logger.get('API').error('catalog.getWidgetItems', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const searchItemsByName = async (
  data: ISearchCatalogItemsByName
): Promise<ICatalogItemsList> => {
  try {
    const itemsList = {} as ICatalogItemsList;
    return itemsList;
  } catch (error) {
    logger.get('API').error('catalog.searchItemsByName', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const searchItemsByCategory = async (
  data: ISearchCatalogItemsByCategory
): Promise<ICatalogItemsList> => {
  try {
    const itemsList = {} as ICatalogItemsList;
    return itemsList;
  } catch (error) {
    logger.get('API').error('catalog.searchItemsByCategory', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getSupportedLocales = async (): Promise<ISupportedLocalesList> => {
  try {
    return { locales: [] };
  } catch (error) {
    logger.get('API').error('catalog.getSupportedLocales', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const updateUserLocalePreferences = async (
  data: IUserLocaleChange
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('catalog.updateUserLocalePreferences', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getNewsFeed = async (data: IGetNewsfeed): Promise<INewsfeed> => {
  try {
    const newsfeed = { values: [], cursor: '' };
    return newsfeed;
  } catch (error) {
    logger.get('API').error('catalog.getNewsFeed', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const hideNewsfeedPosts = async (data: IHideNewsfeedPosts): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('catalog.hidePostsInNewsFeed', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const unhideNewsfeedPosts = async (
  data: IUnhideNewsfeedPosts
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('catalog.unhidePostsInNewsFeed', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getStartPageItems = async <T extends StartPageItemType>(
  data: IGetStartPageItems
): Promise<IStartPageItems<T>> => {
  try {
    const response = {} as IStartPageItems<T>;
    return response;
  } catch (error) {
    logger.get('API').error('catalog.getStartPageItems', error);
    throw buildModelError(error);
  }
};
